import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Button, ShortModal } from '@sbt-web/ui';
import { adsPublishedDialogView } from './tracking';
import UserAdsDetail from './components/UserAdsDetail';
import { PrivateUserAdsPublishedCounterProps } from './types';
export const PrivateUserAdsPublishedCounter = t0 => {
  const $ = _c(32);
  const {
    item,
    categories,
    numberOfAdsPublished,
    buttonClassName,
    labelClassName,
    counterClassName
  } = t0;
  const [isCategoryDialogOpened, setIsCategoryDialogOpened] = useState(false);
  if (!numberOfAdsPublished) {
    return;
  }
  let t1;
  if ($[0] !== categories || $[1] !== item) {
    t1 = () => {
      if (!categories || !item) {
        return;
      }
      adsPublishedDialogView(item);
      setIsCategoryDialogOpened(true);
    };
    $[0] = categories;
    $[1] = item;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleButtonClick = t1;
  let t2;
  if ($[3] !== counterClassName || $[4] !== numberOfAdsPublished) {
    t2 = <span className={counterClassName}>{numberOfAdsPublished}</span>;
    $[3] = counterClassName;
    $[4] = numberOfAdsPublished;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = numberOfAdsPublished === 1 ? "Annuncio pubblicato" : "Annunci pubblicati";
  let t4;
  if ($[6] !== labelClassName || $[7] !== t3) {
    t4 = <p className={labelClassName}>{t3}</p>;
    $[6] = labelClassName;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const content = t5;
  if (categories) {
    const t6 = buttonClassName ?? "";
    let t7;
    if ($[12] !== t6) {
      t7 = [t6];
      $[12] = t6;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== content || $[15] !== handleButtonClick || $[16] !== t7) {
      t8 = <Button design="text" classes={t7} onClick={handleButtonClick}>{content}</Button>;
      $[14] = content;
      $[15] = handleButtonClick;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = () => {
        setIsCategoryDialogOpened(false);
      };
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = {
        main: {
          text: "Chiudi",
          design: "text",
          action: () => {
            setIsCategoryDialogOpened(false);
          }
        }
      };
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    let t11;
    if ($[20] !== categories || $[21] !== numberOfAdsPublished) {
      t11 = <UserAdsDetail totalAds={numberOfAdsPublished} categories={categories} />;
      $[20] = categories;
      $[21] = numberOfAdsPublished;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    let t12;
    if ($[23] !== isCategoryDialogOpened || $[24] !== t11) {
      t12 = <ShortModal open={isCategoryDialogOpened} ariaDescription="Categorie di pubblicazione" onClose={t9} title="Categorie di pubblicazione" buttonConfiguration={t10}>{t11}</ShortModal>;
      $[23] = isCategoryDialogOpened;
      $[24] = t11;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    let t13;
    if ($[26] !== t12 || $[27] !== t8) {
      t13 = <>{t8}{t12}</>;
      $[26] = t12;
      $[27] = t8;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    return t13;
  }
  let t6;
  if ($[29] !== buttonClassName || $[30] !== content) {
    t6 = <div className={buttonClassName}>{content}</div>;
    $[29] = buttonClassName;
    $[30] = content;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
};